import React, { useState, useEffect } from "react";
import FlexContainer from "./FlexContainer";
import axios from "axios";
import { API_URL, RegionalApiManager, LoginType } from "src/scenes/App";
import styled from "styled-components";
import Footer from "./Footer";
import LogoImg2 from "../img/new/me_logo.svg";
import Text from "./Text";
import { InitialPasswordContainerContext } from "./InitialPasswordContainerContext";
import { TOKEN_TYPE } from "src/constants/tokenType";
import { AuthPageContent } from "./AuthComponents";

/* ---------------- Styled Components ---------------- */
const Container = styled.header`
  background: ${(p) =>
        p.url ? `url(${p.url}) no-repeat center ${p.location || "top"}` : null};
  background-color: ${(p) => (p.transparent ? "transparent" : p.backgroundColor)};
  flex: 0;
  top: ${(p) => p.top};
  transition: background-color 0.3s;
  width: 100%;
`;

const Content = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0px;
  width: 100%;
  text-align: center;
`;

const Logo = styled.div``;

const CenterHeader = ({ top, url, transparent, logoImg, backgroundColor }) => (
    <Container transparent={transparent} top={top} url={url} backgroundColor={backgroundColor}>
        <Content>
            <Logo>{logoImg}</Logo>
        </Content>
    </Container>
);

const TokenExpired = () => (
    <FlexContainer style={{ margin: "auto" }} family="Manrope, Helvetica, sans-serif">
        <Text size="30px" color="#FFF" weight="500">
            Link Expired
        </Text>
        <Text margin="10px" size="16px" color="#FFF" weight="500">
            The link is no longer valid.
        </Text>
    </FlexContainer>
);

const InitialPasswordContainer = ({ match, children }) => {
    const [fetching, setFetching] = useState(0);
    const [accessCode, setAccessCode] = useState("");
    const [businessName, setBusinessName] = useState("");
    const [isValidInitialPasswordToken, setIsValidInitialPasswordToken] = useState(false);

    const shortTermToken = match.params.shortTermToken;

    useEffect(() => {
        const init = async () => {
            setFetching((prev) => prev + 1);

            try {
                const region = await RegionalApiManager.locateUser(LoginType.ShortTermToken, shortTermToken);
                RegionalApiManager.setRegionData(region); // Assigns API_URL

                const res = await axios.get(`${API_URL}/validateShortTermKey/${shortTermToken}/${TOKEN_TYPE.INITIAL_PASSWORD}`);
                const { accessToken, companyName } = res.data;

                setIsValidInitialPasswordToken(true);
                setAccessCode(accessToken);
                setBusinessName(companyName);
            } catch (error) {
                console.error("Short term token validation failed:", error);
            } finally {
                setFetching((prev) => prev - 1);
            }
        };

        init();
    }, [shortTermToken]);

    const imageContainer = (imageUrl) => (
        <FlexContainer direction="row" alignItems="center">
            <img src={imageUrl} alt="Company Logo" style={{ height: "29px", objectFit: "contain" }} />
        </FlexContainer>
    );

    if (fetching > 0) {
        return (
            <FlexContainer style={{ margin: "auto", width: "40vw" }}>
                <Text size="30px" color="#000" weight="500">
                    Setup Password
                </Text>
                <Text margin="10px" size="16px" color="#000" weight="500">
                    Please wait while we connect you to your account...
                </Text>
            </FlexContainer>
        );
    }

    return (
        <FlexContainer alignItems="center" minHeight="100vh" style={{ backgroundColor: "#171A22" }}>
            <CenterHeader logoImg={imageContainer(LogoImg2)} backgroundColor="#000" />

            <AuthPageContent>
                {!isValidInitialPasswordToken && <TokenExpired />}

                {isValidInitialPasswordToken && (
                    <InitialPasswordContainerContext.Provider
                        value={{
                            accessCode,
                            businessName,
                            shortTermToken: match.params.shortTermToken,
                        }}
                    >
                        {children}
                    </InitialPasswordContainerContext.Provider>
                )}
            </AuthPageContent>

            <Footer />
        </FlexContainer>
    );
};

export default InitialPasswordContainer;
